import React from 'react';
import { routes } from '../../../config/routes/routes';
import { apiRoutes } from '../../../config/api/apiRoutes';
import { SidebarItems } from '../../../config/sidebar/sidebar.types';
import BadgeIcon from '@mui/icons-material/Badge';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import EngineeringIcon from '@mui/icons-material/Engineering';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import AlarmOffIcon from '@mui/icons-material/AlarmOff';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import PersonIcon from '@mui/icons-material/Person';

export const ERP_SIDEBAR_ITEMS: SidebarItems = {
  general: [
    {
      title: 'SIDEBAR.MY_PROFILE',
      icon: <PersonIcon />,
      url: routes.admin.employees.employeeProfile,
      apiUrl: apiRoutes.employees.employeeProfile,
    },
    {
      title: 'SIDEBAR.TASKS',
      icon: <DeveloperBoardIcon />,
      url: routes.admin.processes.listByEmployee,
      apiUrl: apiRoutes.processes.listByEmployee,
    },
    {
      title: 'SIDEBAR.DOCUMENTS',
      icon: <DocumentScannerIcon />,
      url: routes.admin.documents.listForEmployee,
      apiUrl: apiRoutes.documents.listForEmployee,
    },
    {
      title: 'SIDEBAR.SCHEDULE',
      icon: <AlarmOffIcon />,
      url: routes.admin.workTimes.scheduleForEmployee,
      apiUrl: apiRoutes.employees.listAvailabilityForEmployee,
    },
  ],
  settings: [
    {
      title: 'SIDEBAR.DOCUMENT_TEMPLATES',
      icon: <DocumentScannerIcon />,
      url: routes.admin.globalDocumentTemplates.list,
      apiUrl: apiRoutes.globalDocumentTemplates.list,
    },
    {
      title: 'SIDEBAR.PROCESS_SETTINGS',
      icon: <DeveloperBoardIcon />,
      url: routes.admin.globalProcessSettings.list,
      apiUrl: apiRoutes.globalProcessSettings.list,
    },
  ],
  company: [
    {
      title: 'SIDEBAR.PROCESSES',
      icon: <DeveloperBoardIcon />,
      url: routes.admin.processes.list,
      apiUrl: apiRoutes.processes.list,
    },
    {
      title: 'SIDEBAR.EMPLOYEES',
      icon: <BadgeIcon />,
      url: routes.admin.employees.list,
      apiUrl: apiRoutes.employees.list,
    },
    {
      title: 'SIDEBAR.DOCUMENTS',
      icon: <DocumentScannerIcon />,
      url: routes.admin.documents.list,
      apiUrl: apiRoutes.documents.list,
    },
    {
      title: 'SIDEBAR.JOB_TITLES',
      icon: <EngineeringIcon />,
      url: routes.admin.jobTitles.list,
      apiUrl: apiRoutes.jobTitles.list,
    },
    {
      title: 'SIDEBAR.DEPARTMENTS',
      icon: <EmojiTransportationIcon />,
      url: routes.admin.departments.list,
      apiUrl: apiRoutes.departments.list,
    },
    {
      title: 'SIDEBAR.SCHEDULE',
      icon: <AlarmOffIcon />,
      url: routes.admin.workTimes.schedule,
      apiUrl: apiRoutes.employees.listAvailability,
    },
  ],
};

export const ERP_SIDEBAR_COMPONENT_CONFIG = {
  component: null,
};
